import DevisListContent from '@/components/devis/devis-list-content';
import { AVATAR_GROUP_QUOTE_TYPE, ROLE_BIG_READ_QUOTE } from '@/utils/CONST';
import { useAuthenticated, usePermissions } from 'react-admin';

const DevisListGeneral = () => {
    useAuthenticated();

    const { permissions } = usePermissions();

    const filter = { type: AVATAR_GROUP_QUOTE_TYPE };
    const queryEnabled = permissions?.includes(ROLE_BIG_READ_QUOTE) ?? false;

    return (
        <DevisListContent
            filter={filter}
            queryEnabled={queryEnabled}
            loading={false}
        />
    );
};

export default DevisListGeneral;
